export class PrestationContratsAssocies {
  prestationRequest: PrestationRequest;
  contrats: ContratAggregate[];
  constructor(prestationRequest: PrestationRequest, contrats: ContratAggregate[]) {
    this.prestationRequest = prestationRequest;
    this.contrats = contrats;
  }
}

export class ContratAggregate {
  id: number;
  libelle: string;
  entiteGestion: string;
  codeSocieteJuridique: string;
  commentaire: string;
  constructor(id: number, libelle: string, entiteGestion: string, codeSocieteJuridique: string, commentaire: string) {
    this.id = id;
    this.libelle = libelle;
    this.entiteGestion = entiteGestion;
    this.codeSocieteJuridique = codeSocieteJuridique;
    this.commentaire = commentaire;
  }
}

export class PrestationRequest {
  prestationId: number;
  contratIds: number[];
  constructor(prestationId: number, contratIds: number[]) {
    this.prestationId = prestationId;
    this.contratIds = contratIds;
  }
}
